<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Parámetros de Inflación">
          <b-table hover
              responsive="sm"
              class="registro"
              :busy="tableBusy" 
              :items="parametros" 
              :fields="parametrosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(pjeInflacion)="data">
              {{ data.item.pjeInflacion | numero(2, true) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Período</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Período</b-dropdown-item>
          <b-dropdown-item @click.stop="borrar">
            <i class="fa fa-times"></i>Borrar Período</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'parametrosinflacion/getField',
  mutationType: 'parametrosinflacion/updateField',
});

export default {
  name: 'ParametrosInflacion',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      parametrosFields: [
        /*{key: 'id'},*/
        {
          key: 'periodo',
        },
        {
          key: 'pjeInflacion',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'parametros',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems()
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('parametrosinflacion/getParametros')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    agregar () {
      this.$router.push({ name: 'ParametroInflacionABM',
                          params: { id: 0 } });
    },
    editar (item) {
      this.$router.push({ name: 'ParametroInflacionABM',
                          params: { id: item.id } });
    },
    borrar() {
      this.showModalConfirm('¿Desea borrar el último período registrado?', 
            this.borrarPeriodo, 'Si', null, 'No')
    },
    borrarPeriodo() {
      this.showSpinner();
      this.$store.dispatch('parametrosinflacion/delete')
        .then(() => this.showModalMsj('El período se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
</style>
